import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { login, logout, check, switchAuth } from '../api/auth.api';
import { IAuth, IGetAuth, IAuthReq, InitialAuth } from '../models/auth.model';
import { AppThunk } from './index';

interface IVerifyState {
  
  isLoading: boolean;
  data: {
    status: 'SM' | 'EM';
    certifyValue: string;
    token: string;
    certifyKey: string;
    isExpired: boolean;

    webId: string;
    memberName: string;
    value: string;
    
  },
  timer: {
    status: boolean;
    second: number;
    isReset: boolean;
  }

  isVerify: boolean;
  error?: AxiosError | string;
}

const initialState: IVerifyState = {
  isLoading: false,
  data: {
    status: 'SM',
    certifyValue: '',
    token: '',
    certifyKey: '',
    isExpired: false,
    webId: '',
    memberName: '',
    value: ''
  }, 
  timer: {
    status: false,
    second: 0,
    isReset: false
  },
  
  isVerify: false
};

const verifySlicer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    requestStart: (state: IVerifyState) => {
      state.isLoading = true;
      state.error = undefined;
      state.isVerify = false;
    },
    requestFailure: (state: IVerifyState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isVerify = false;
    },
    resetVerify: (state: IVerifyState) => {
      state.isLoading = false;
      state.data = {
        status: 'SM',
        certifyValue: '',
        token: '',
        certifyKey: '',
        isExpired: false,
        webId: '',
        memberName: '',
        value: ''
      };
      state.isVerify = false;
    },
    setVerify: (state: IVerifyState, action: PayloadAction<IVerifyState['data']>) => {
      state.data = action.payload;
    },
    setToken: (state: IVerifyState, action: PayloadAction<string>) => {
      state.data.token = action.payload;
    },
    setCertifyKey: (state: IVerifyState, action: PayloadAction<string>) => {
      state.data.certifyKey = action.payload;
    },
    setCertifyValue: (state: IVerifyState, action: PayloadAction<string>) => {
      state.data.certifyValue = action.payload;
    },
    setIsExpired: (state: IVerifyState, action: PayloadAction<boolean>) => {
      state.data.isExpired = action.payload;
    },
    setWebId: (state: IVerifyState, action: PayloadAction<string>) => {
      state.data.webId = action.payload;
    },
    setMemberName: (state: IVerifyState, action: PayloadAction<string>) => {
      state.data.memberName = action.payload;
    },
    setIsVerify: (state: IVerifyState, action: PayloadAction<boolean>) => {
      state.isVerify = action.payload;
    },
    
    resetVerifyTimer: (state: IVerifyState) => {
      state.timer.status = false;
      state.timer.second = 0;
      state.timer.isReset = false;
    },

    startTimer: (state: IVerifyState) => {
      state.isVerify = false;
      state.data.isExpired = false;
      state.timer.status = true;
    },
    stopTimer: (state: IVerifyState) => {
      state.timer.status = false;
    },

  }
});

export const {
  requestStart,
  requestFailure,
  resetVerify,
  setVerify,
  setToken,
  setCertifyKey,
  setCertifyValue,
  setIsExpired,
  setWebId,
  setMemberName,
  setIsVerify,
  startTimer,
  stopTimer,
  resetVerifyTimer
} = verifySlicer.actions;

export default verifySlicer.reducer;

export const doLogin = (data: IAuthReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await login(data);
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
